export default __webpack_public_path__ + "8e8a7d574664e0b13ce4fcd2a288285e.pdf";